export type ShareResult = 'shared' | 'copied' | 'prompted' | 'cancelled' | 'failed';

interface ShareOptions {
  title?: string;
  text?: string;
  url?: string;
}

export const copyTextToClipboard = async (text: string): Promise<boolean> => {
  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      // Continue to legacy fallback when clipboard write is unavailable or blocked.
    }
  }

  try {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.setAttribute('readonly', 'true');
    textArea.style.position = 'absolute';
    textArea.style.left = '-9999px';
    document.body.appendChild(textArea);
    textArea.select();
    const success = document.execCommand('copy');
    document.body.removeChild(textArea);
    return success;
  } catch (error) {
    return false;
  }
};

export const shareCombatTv = async (options: ShareOptions = {}): Promise<ShareResult> => {
  const url = options.url ?? window.location.href;
  const title = options.title ?? document.title ?? 'Combat TV';
  const text = options.text ?? 'Check out Combat TV for live and on-demand fight content.';
  const shareData = { title, text, url };

  if (navigator.share) {
    try {
      if (!navigator.canShare || navigator.canShare(shareData)) {
        await navigator.share(shareData);
        return 'shared';
      }
    } catch (error) {
      if (error instanceof DOMException && error.name === 'AbortError') {
        return 'cancelled';
      }
    }
  }

  const copied = await copyTextToClipboard(url);
  if (copied) {
    return 'copied';
  }

  const promptResult = window.prompt('Copy this link to share Combat TV:', url);
  if (promptResult !== null) {
    return 'prompted';
  }

  return 'failed';
};
